import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ORDER_CHANNEL_KEY, OrderChannels } from '../types/orderChannels';
import { PartnerWizardComponent } from '../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardButtonsOrderTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardButtonsOrderTemplate: FunctionalComponent<PartnerWizardButtonsOrderTemplateProps> = ({
  controller,
}) => {
  const channels: OrderChannels = controller.wizardData.orderChannels;

  return (
    <div
      class={`root-buttons direction-${controller.buttonsDirection}${controller.buttonsDirectOrderReversed ? '-reverse' : ''} buttons-order`}
    >
      {channels.online && (
        <div>
          <a
            onClick={() =>
              controller.onEditorLinkClicked.emit({
                keyAccount: controller.getCurrentKeyAccount(),
                external: controller.getCurrentKeyAccount() !== controller.keyAccount,
                target: channels.online,
              })
            }
            href={channels.online}
            class={`button-${controller.buttonOrderOnlineVariant} button-order-online`}
            part={'button-order-online'}
            data-keyaccount={controller.getCurrentKeyAccount()}
          >
            {controller.textOrderOnlineButton}
          </a>
        </div>
      )}

      {channels.software && (
        <div>
          <a
            onClick={() =>
              controller.onSoftwareLinkClicked.emit({
                keyAccount: controller.getCurrentKeyAccount(),
                external: controller.getCurrentKeyAccount() !== controller.keyAccount,
                type: channels.software.type,
                os: channels.software.os,
                target: channels.software.link,
              })
            }
            href={channels.software.link}
            class={`button-${controller.buttonOrderSoftwareVariant} button-order-software`}
            data-keyaccount={controller.getCurrentKeyAccount()}
            part={'button-order-software'}
          >
            {channels.software.type === ORDER_CHANNEL_KEY.MOBILE_SOFTWARE
              ? controller.textOrderMpsButton
              : controller.textOrderHpsButton}
          </a>
        </div>
      )}
    </div>
  );
};

export default PartnerWizardButtonsOrderTemplate;
